export const DATAVALIDATIONFIELDS = ['Counterparty', 'TrsFinancingRate', 'TrsFinancingRateType', 'TradeDate', 'EffectiveDate', 'ScheduledMaturityDate', 'FinalSettlementDate', 'MainAccountAllocation', 'PortfolioId', 'TransactionType']

export const DATACHECKINGFIELDS = [...DATAVALIDATIONFIELDS, 'EarlyTerminationDate']

export const BOND_EDITABLE_FIELDS = ['Quantity', 'Fitch', 'Moody', 'SAndP', 'TraderPrice']

export const EQUITY_EDITABLE_FIELDS = ['Quantity']
